import { render } from "./SessionInfoLegacy.vue?vue&type=template&id=3e96a47f"
import script from "./SessionInfoLegacy.vue?vue&type=script&lang=js"
export * from "./SessionInfoLegacy.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__